// extracted by mini-css-extract-plugin
export default {"root":"BackButton_root__wHI8w"};